import {
  HOME_FETCH_EMAIL_BEGIN,
  HOME_FETCH_EMAIL_SUCCESS,
  HOME_FETCH_EMAIL_FAILURE,
  HOME_FETCH_EMAIL_DISMISS_ERROR,
} from './constants';


import axios from 'axios';


// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchEmail(id, pcoId) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_FETCH_EMAIL_BEGIN,
      id: id
    });

    const promise = new Promise((resolve, reject) => {
      axios.get("/api/values/mail/"+pcoId).then(
        (res) => {
          dispatch({
            type: HOME_FETCH_EMAIL_SUCCESS,
            id,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_FETCH_EMAIL_FAILURE,
            id,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchEmailError() {
  return {
    type: HOME_FETCH_EMAIL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_FETCH_EMAIL_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        workers:
        {
          ...state.workers,
          [action.id]: 
          {
            ...state.workers[action.id],
            fetchEmailPending: true,
            fetchEmailError: null,
          }
        }
        
      };

    case HOME_FETCH_EMAIL_SUCCESS:
      // The request is success
      return {
         ...state,
        workers:
        {
          ...state.workers,
          [action.id]: 
          {
            ...state.workers[action.id],
            fetchEmailPending: false,
            fetchEmailError: null,
            email: action.data.email
          }
        }
        
      };

    case HOME_FETCH_EMAIL_FAILURE:
      // The request is failed
      return {
        ...state,
        workers:
        {
          ...state.workers,
          [action.id]: 
          {
            ...state.workers[action.id],
          fetchEmailPending: false,
          fetchEmailError: action.data.error,
          }
        }
      };

    case HOME_FETCH_EMAIL_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
         ...state,
        workers:
        {
          ...state.workers,
          [action.data]: 
          {
            ...state.workers[action.data],
            fetchEmailError: null,
          }
        }
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/fetchEmail.js